import type { ContentHref } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import { Popover } from '@mui/material';
import type { ProposalMetaInfo } from '@newStore/documentUI/documentUITypes';
import { selectNodeDiffText } from '@newStore/documentUI/transformProposal/proposalSelectors';
import { useSelector } from 'react-redux';
import './ProposalDiffMessage.scss';

const ProposalDiffMessage: React.FC<{
  href: ContentHref;
  parentHref: ContentHref | null;
  proposalMetaInfo: ProposalMetaInfo;
  userColor: string;
  anchorEl: HTMLElement;
}> = ({ href, parentHref, proposalMetaInfo, userColor, anchorEl }) => {
  let diffText = useSelector((state: RootState) => selectNodeDiffText(state, href, parentHref));

  if (proposalMetaInfo.childProposalsMessage) {
    diffText += `<li>${proposalMetaInfo.childProposalsMessage.message}</li>`;
  }

  if (diffText === '') {
    diffText = 'Er zijn geen wijzigingen (meer) voor deze node.';
  }

  return (
    <Popover
      id="mouse-over-popover"
      sx={{
        pointerEvents: 'none',
      }}
      open={true}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableRestoreFocus
    >
      <div className="proposal-diff">
        <div className="proposal-diff-header">
          <span style={{ color: userColor }}>
            {'Wijzigingen door:'}
            <strong>{` ${proposalMetaInfo.authorsDescription}${
              proposalMetaInfo.submittedOn ? ` - ${proposalMetaInfo.submittedOn}` : ''
            }`}</strong>
          </span>
        </div>
        <div className="proposal-diff-text" dangerouslySetInnerHTML={{ __html: diffText }} />
      </div>
    </Popover>
  );
};

export default ProposalDiffMessage;
